// @flow
const locales = [
  { locale: 'zh-hant', name: '繁體中文', fallback: 'zh', wordBreakBySpace: false, disable: false, dir: "ltr" },
  { locale: 'zh-hans', name: '简体中文', fallback: 'gb', wordBreakBySpace: false, disable: false, dir: "ltr" },
  { locale: 'pt', name: 'Português', fallback: 'pt', wordBreakBySpace: true, disable: false, dir: "ltr" },
  { locale: 'en', name: 'English', fallback: 'en', wordBreakBySpace: true, disable: false, dir: "ltr" },
  { locale: 'ja', name: '日本語', fallback: 'jp', wordBreakBySpace: false, disable: false, dir: "ltr" },
  { locale: 'ko', name: '한국어', fallback: 'kr', wordBreakBySpace: true, disable: false, dir: "ltr" },
  { locale: 'th', name: 'ภาษาไทย', fallback: 'th', wordBreakBySpace: true, disable: false, dir: "ltr" },
  // { locale: 'ms', name: 'Bahasa Malaysia', fallback: 'my', wordBreakBySpace: true, disable: false, dir: "ltr" },
  { locale: 'id', name: 'Bahasa Indonesia', fallback: 'id', wordBreakBySpace: true, disable: false, dir: "ltr" },
  // { locale: 'de', name: 'Deutsch', fallback: 'de', wordBreakBySpace: true, disable: false, dir: "ltr" },
  // { locale: 'fr', name: 'Français', fallback: 'fr', wordBreakBySpace: true, disable: false, dir: "ltr" },
  // { locale: 'es', name: 'Español', fallback: 'es', wordBreakBySpace: true, disable: false, dir: "ltr" },
  // { locale: 'it', name: 'Italiano', fallback: 'it', wordBreakBySpace: true, disable: false, dir: "ltr" },
  { locale: 'ru', name: 'Pусский', fallback: 'ru', wordBreakBySpace: true, disable: true, dir: "ltr" },
  // { locale: 'ar', name: 'عربي', fallback: 'ae', wordBreakBySpace: true, disable: false, dir: "rtl" },
];

export default locales;